import { Suspense } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import SectionTabs from '../../../components/common/SectionTabs.jsx'
import { Loader2 } from 'lucide-react'
import { hasModule } from '../../access/modules.js'
import { useCurrentUser } from '../../../hooks/useCurrentUser.js'
import { CRM_BASES } from '../bases.js'

/**
 * CRM : toutes les bases au même endroit, avec un sélecteur.
 *   /dashboard/crm         -> première base accessible
 *   /dashboard/crm/:base   -> la base choisie
 */
export default function CrmPage() {
  const { base: baseKey } = useParams()
  const { user, isLoading } = useCurrentUser()

  if (isLoading) return null

  const bases = CRM_BASES.filter((b) => !b.module || hasModule(user, b.module))
  const base = bases.find((b) => b.key === baseKey)
  if (!base) {
    return bases.length > 0 ? <Navigate to={`/dashboard/crm/${bases[0].key}`} replace /> : null
  }

  const Screen = base.component

  return (
    <div>
      <SectionTabs
        label="Bases du CRM"
        activeKey={base.key}
        tabs={bases.map((b) => ({ ...b, to: `/dashboard/crm/${b.key}` }))}
      />
      <Suspense
        fallback={(
          <div className="flex items-center justify-center py-20 text-white/50">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
        )}
      >
        <Screen />
      </Suspense>
    </div>
  )
}
